import { constantToLabel } from 'common/utils';

import { OptionItem } from '../types';

export const enumToOptionItems = (enumObject: Record<string, string | number>): OptionItem[] =>
  Object.entries(enumObject).map(([key, value]) => {
    const label = constantToLabel(typeof value === 'string' ? value : key.toString());
    return { value, label };
  });
